import React from 'react';
import ConsultationForm from '../components/ConsultationForm';
import { useLanguage } from '../contexts/LanguageContext';

const ConsultationPage = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-kamit-beige pt-24 pb-16" data-testid="consultation-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="font-heading text-4xl md:text-5xl text-kamit-brown mb-4">
            {language === 'fr' ? 'Consultation Lifestyle' 
              : language === 'pt' ? 'Consulta Lifestyle' 
              : language === 'de' ? 'Lifestyle-Beratung'
              : language === 'es' ? 'Consulta Lifestyle'
              : 'Lifestyle Consultation'}
          </h1>
          <p className="text-kamit-brown/70 text-lg max-w-2xl mx-auto">
            {language === 'fr' 
              ? 'Veuillez remplir ce formulaire avant votre rendez-vous pour nous aider à personnaliser votre expérience.'
              : language === 'pt'
              ? 'Por favor, preencha este formulário antes da sua consulta para nos ajudar a personalizar a sua experiência.'
              : language === 'de'
              ? 'Bitte füllen Sie dieses Formular vor Ihrem Termin aus, damit wir Ihr Erlebnis personalisieren können.'
              : language === 'es'
              ? 'Por favor, complete este formulario antes de su cita para ayudarnos a personalizar su experiencia.'
              : 'Please complete this form before your appointment to help us personalize your experience.'}
          </p>
          <div className="w-24 h-1 bg-kamit-gold mx-auto mt-4" />
        </div>
        
        <ConsultationForm standalone={true} />
      </div>
    </div>
  );
};

export default ConsultationPage;
